import React from 'react';
import { getAdminUrl } from '../../../lib/getAdminUrl.js';
import { ToolbarItem } from '../index.js';
export function Edit({ seedNode }) {
    if (seedNode === undefined ||
        (seedNode === null || seedNode === void 0 ? void 0 : seedNode.isFrontPage) ||
        (seedNode === null || seedNode === void 0 ? void 0 : seedNode.isPostsPage)) {
        return null;
    }
    // eslint-disable-next-line no-underscore-dangle
    const postType = (seedNode === null || seedNode === void 0 ? void 0 : seedNode.__typename) || '';
    const postId = (seedNode === null || seedNode === void 0 ? void 0 : seedNode.databaseId) || '';
    const editPostUrl = getAdminUrl(`post.php?post=${postId}&action=edit`);
    return React.createElement(ToolbarItem, { href: editPostUrl },
        "Edit ",
        postType);
}
